import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { WHATSAPP_URL, scrollToId, trackClick } from "../../lib/site";

const LINKS = [
  { label: "O que eu atendo", href: "#demandas" },
  { label: "A abordagem", href: "#abordagem" },
  { label: "Pilares", href: "#pilares" },
  { label: "Sobre mim", href: "#sobre" },
  { label: "Dúvidas", href: "#duvidas" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-sand/85 backdrop-blur-xl shadow-[0_1px_0_rgba(45,51,47,0.06)]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <button
          data-testid="header-logo"
          onClick={() => scrollToId("#inicio")}
          className="text-left"
        >
          <span className="font-serif text-xl font-semibold tracking-tight text-bark">
            Vanessa Calsavara
          </span>
          <span className="block text-[10px] font-semibold uppercase tracking-[0.3em] text-moss">
            Psicóloga · CRP 06/148265
          </span>
        </button>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="header-nav">
          {LINKS.map((link) => (
            <button
              key={link.href}
              data-testid={`nav-link-${link.href.slice(1)}`}
              onClick={() => scrollToId(link.href)}
              className="text-sm font-medium text-moss transition-colors duration-300 hover:text-bark"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="header-cta-button"
            href={WHATSAPP_URL}
            onClick={() => trackClick("header")}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-brand px-6 py-2.5 text-sm font-semibold text-sand shadow-[0_8px_24px_rgba(58,77,57,0.25)] transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-brand-deep hover:shadow-[0_12px_28px_rgba(58,77,57,0.3)]"
          >
            Agendar sessão
          </a>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-bark/15 text-bark transition-colors duration-300 hover:bg-bone lg:hidden"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="mobile-menu"
          className="border-t border-bark/8 bg-sand/95 backdrop-blur-xl lg:hidden"
        >
          <div className="flex flex-col px-6 py-4">
            {LINKS.map((link) => (
              <button
                key={link.href}
                data-testid={`mobile-nav-link-${link.href.slice(1)}`}
                onClick={() => {
                  setOpen(false);
                  scrollToId(link.href);
                }}
                className="border-b border-bark/8 py-4 text-left text-base font-medium text-bark transition-colors duration-300 last:border-0 hover:text-brand"
              >
                {link.label}
              </button>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};
